import { GetStaticPaths, GetStaticProps } from "next";
import BlogIndexPage from "@/components/BlogIndex/BlogIndexPage";
import { BLOG_POSTS_PER_PAGE, getBlogItems } from "@/utils/getBlogItems";
import fetchContentfulGraphql from "@/utils/contentfulGraphql";
import { getBlogPost } from "@/utils/getBlogPost";
import BlogPost from "@/components/BlogPage/BlogPage";

const Page = ({ ...props }: any) => {
  return props.blogPost ? (
    <BlogPost {...props} />
  ) : (
    <BlogIndexPage {...props} />
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await fetchContentfulGraphql(`{
    blogPostCollection(limit: 1000) {
      total
      items {
        slug
      }
    }
  }`);

  const pages = Math.ceil(data.blogPostCollection.total / BLOG_POSTS_PER_PAGE);
  const array = Array.from(Array(pages + 1).keys()).slice(2);
  data.blogPostCollection.items.forEach((item: any) => {
    array.push(item.slug);
  });

  return {
    paths: array.map((pageOrSlug) => ({
      params: { pageOrSlug: pageOrSlug.toString() },
    })),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  const { pageOrSlug }: any = ctx.params!;
  const props = isNaN(pageOrSlug)
    ? await getBlogPost(pageOrSlug)
    : await getBlogItems(pageOrSlug);
  return { props };
};

export default Page;
